import { Params } from '../interfaces';

export const transformParamsToArray = (params: Params) =>
  Object.entries(params).map(([key, value]) => ({ key, value }));
